(() => {
  function init(root) {
    if (root.dataset.songReady) return;
    root.dataset.songReady = 'true';
    let request;
    let busy = false;
    let keyboardInput = false;
    root.addEventListener('pointerdown', () => { keyboardInput = false; }, true);
    root.addEventListener('keydown', () => { keyboardInput = true; }, true);
    root.addEventListener('click', event => {
      const thumb = event.target.closest('[data-song-image]');
      if (!thumb || !root.contains(thumb)) return;
      const img = root.querySelector('[data-song-main-image] img');
      if (!img) return;
      img.removeAttribute('srcset');
      img.src = thumb.dataset.songImage;
      img.alt = thumb.dataset.songAlt;
      root.querySelectorAll('[data-song-image]').forEach(button => button.setAttribute('aria-pressed', String(button === thumb)));
    });
    root.addEventListener('submit', event => {
      if (busy || !root.querySelector('[name="id"]').value || root.querySelector('[data-song-add]').disabled) {
        event.preventDefault();
      } else {
        busy = true;
        // Keep the native form submission; no duplicate AJAX add or artificial delay.
        root.querySelector('[data-song-add]').setAttribute('aria-busy', 'true');
      }
    });
    root.addEventListener('change', async event => {
      if (!event.target.matches('[data-song-option]')) return;
      if (request) request.abort();
      const controller = new AbortController();
      request = controller;
      busy = true;
      const status = root.querySelector('[data-song-status]');
      const purchase = root.querySelector('[data-song-purchase]');
      const position = event.target.dataset.position;
      const quantity = purchase.querySelector('[name="quantity"]').value;
      const url = new URL(window.location.href);
      url.searchParams.set('view', 'song-merch');
      url.searchParams.delete('variant');
      url.searchParams.set('section_id', root.dataset.sectionId);
      url.searchParams.set('option_values', [...purchase.querySelectorAll('[data-song-option]')].map(select => select.value).join(','));
      purchase.querySelector('[data-song-add]').disabled = true;
      purchase.setAttribute('aria-busy', 'true');
      status.textContent = status.dataset.loading;
      root.querySelector('[data-song-fallback]').hidden = true;
      try {
        const response = await fetch(url, {signal: controller.signal, credentials: 'same-origin'});
        if (!response.ok) throw new Error('Variant response failed');
        const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
        const next = doc.querySelector('[data-song-purchase]');
        if (!next || !next.querySelector('form')) throw new Error('Variant section missing');
        if (controller !== request) return;
        const restoreFocus = keyboardInput && document.activeElement === event.target;
        purchase.replaceWith(next);
        const qty = next.querySelector('[name="quantity"]');
        const count = Number(quantity);
        if (Number.isFinite(count) && count >= Number(qty.min) && (!qty.max || count <= Number(qty.max)) && (count - Number(qty.min)) % Number(qty.step) === 0) qty.value = quantity;
        const image = doc.querySelector('[data-song-main-image]');
        if (image) root.querySelector('[data-song-main-image]').replaceWith(image);
        const thumbs = doc.querySelector('.tdt-sp__thumbs');
        if (thumbs && root.querySelector('.tdt-sp__thumbs')) root.querySelector('.tdt-sp__thumbs').replaceWith(thumbs);
        if (restoreFocus) next.querySelector(`[data-position="${position}"]`)?.focus({preventScroll: true});
        status.textContent = '';
        const variant = next.querySelector('[name="id"]').value;
        url.searchParams.delete('section_id');
        if (variant) {url.searchParams.set('variant', variant);url.searchParams.delete('option_values');}
        window.history.replaceState(window.history.state, '', url);
        busy = false;
      } catch (error) {
        if (error.name === 'AbortError') return;
        if (controller !== request) return;
        status.textContent = status.dataset.error;
        purchase.removeAttribute('aria-busy');
        root.querySelector('[data-song-fallback]').hidden = false;
        // Do not enable purchase of the stale variant after a failed selection.
        busy = true;
      }
    });
    window.addEventListener('pageshow', event => {if (event.persisted) {busy = false;root.querySelector('[data-song-add]')?.removeAttribute('aria-busy');}});
  }
  document.querySelectorAll('[data-song-product]').forEach(init);
  document.addEventListener('shopify:section:load', event => event.target.querySelectorAll('[data-song-product]').forEach(init));
})();

